import { IOperationAllow, canOperate } from '../common';
import { filter as lfilter } from 'lodash/fp';

export const diLabels = (operations: IOperationAllow[]) =>
  lfilter<{ label: string; value: number; allow: boolean }>({ allow: true })([
    {
      label: 'Revocations',
      value: 0,
      allow: canOperate(operations)('di'),
    },
    {
      label: 'Status of Requests',
      value: 1,
      allow: canOperate(operations)('di'),
    },
    {
      label: 'Legacy Revocations',
      value: 2,
      allow: canOperate(operations)('di'),
    },
    {
      label: 'Legacy Status of Requests',
      value: 3,
      allow: canOperate(operations)('di'),
    },
    {
      label: 'Search Users',
      value: 4,
      allow: canOperate(operations)('di'),
    },
  ]);
